import instance from '../../../api/axios'
import { CreateWeddingEvent, WeddingEvent } from '../types/wedding'

export const getWeddingEvents = async (): Promise<WeddingEvent[]> => {
  const response = await instance.get('/wedding-events')
  return response.data || []
}

export const getWeddingEventBySlug = async (
  slug: string,
): Promise<WeddingEvent> => {
  const response = await instance.get(`/wedding-events/${slug}`)
  return response.data
}

export const createWeddingEvent = async (
  event: CreateWeddingEvent,
): Promise<WeddingEvent> => {
  const response = await instance.post('/wedding-events', event)
  return response.data
}

export const updateWeddingEvent = async (
  event: WeddingEvent,
): Promise<WeddingEvent> => {
  const response = await instance.put('/wedding-events', event)
  return response.data
}

export const deleteWeddingEvent = async (id: string): Promise<void> => {
  const response = await instance.delete(`/wedding-events/${id}`)
  return response.data
}
